<script lang="ts">

    export let date: Date;

    let dateFormat: string = '';

    $: formatDate(date);

    function formatDate(date: Date): void {
        const formatter = new Intl.DateTimeFormat('es-ES', {
            dateStyle: 'medium',
            timeStyle: 'short'
        });
        dateFormat = formatter.format(date);
    } 

</script>

{dateFormat}
